import {
    $createRangeSelection,
    $createTextNode,
    $getSelection,
    $isRangeSelection,
    LexicalEditor
} from "lexical"
import {sanitizeUrl} from "../utils/url"
import {TOGGLE_LINK_COMMAND} from "@lexical/link"

const debug = false
// const debug = "lexicalInsertLink"

export function lexicalInsertLink(editor: LexicalEditor) {
    gd.modals.oneInput('Link URL', 'https://www.goodday.work', 'Add link', (linkURL:string)=>{
        gd.modal.hide()

        lexicalAddLink(editor, linkURL)
    })
}

export function lexicalAddLink(editor: LexicalEditor, linkURL:string, linkText?:string) {
    editor.update(() => {
        let selection:any = $getSelection()
        if (!$isRangeSelection(selection)) selection = $createRangeSelection()

        debug && console.log(debug, 'update', $isRangeSelection(selection), selection)

        if (linkText) {
            const textNode = $createTextNode(linkText)
            selection.insertNodes([textNode])
        } else if (selection.focus.offset === selection.anchor.offset) {
            const textNode = $createTextNode(sanitizeUrl(linkURL))
            selection.insertNodes([textNode])
        }

        editor.dispatchCommand(TOGGLE_LINK_COMMAND, sanitizeUrl(linkURL));
    })
}
